import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  MemberSummaryFeedbackDialog,
  MemberSummaryFeedbackDialogCallbackInput,
  MemberSummaryFeedbackDialogUniqueProps,
} from '../member-summary-feedback-dialog';

const { useDialogForContext, useDialog: useMemberSummaryFeedbackDialog } =
  getDialogHooks<
    MemberSummaryFeedbackDialogUniqueProps,
    MemberSummaryFeedbackDialogCallbackInput
  >(MemberSummaryFeedbackDialog);
export const useMemberSummaryFeedbackDialogForContext = useDialogForContext;
export default useMemberSummaryFeedbackDialog;
